module.exports = {
          srcSet: "/_next/static/images/img-informatique@2x-160-72ec2599986085a3a637bd53cc996139.jpg"+" 160w"+","+"/_next/static/images/img-informatique@2x-292-960770ee4a17daa2f31c6857be3b1a69.jpg"+" 292w",
          images:[ {path: "/_next/static/images/img-informatique@2x-160-72ec2599986085a3a637bd53cc996139.jpg",width: 160,height: 137},{path: "/_next/static/images/img-informatique@2x-292-960770ee4a17daa2f31c6857be3b1a69.jpg",width: 292,height: 250}],
          src: "/_next/static/images/img-informatique@2x-160-72ec2599986085a3a637bd53cc996139.jpg",
          toString:function(){return "/_next/static/images/img-informatique@2x-160-72ec2599986085a3a637bd53cc996139.jpg"},
          placeholder: undefined,
          width: 160,
          height: 137
      }